import React from 'react'
import moment from 'moment'

import Icon from '../../components/UI/Icon'
import UpcomingClassLanguage from '../common/Statistic/UpcomingClassLanguage'

import { getUserName } from '../../helpers'

import { imagePrefix, priceTypes } from '../../constants'

const Job = ({ job, onDetails }) => {
  const priceType = priceTypes.find((priceType) => job.price_type === priceType.value)

  const handleDetails = () => {
    onDetails(job)
  }

  const languagesContent = job.creator_profile.languages.map((language) => {
    return <UpcomingClassLanguage key={language.iso_639_1_code} language={language} />
  })

  return (
    <div className="w-full bg-[#FEEBDD] rounded-[10px] flex flex-col items-center p-[10px] border-[#F79009] border-[1px] shadow-sm">
      <div className="w-full flex items-center">
        <div className="relative w-[268px] h-[358px]">
          {false && (
            <div className="absolute top-[8px] left-[8px] z-[1] px-[8px] py-[6px] rounded-[8px] bg-primary-button flex items-center justify-center">
              <Icon name="marketing" color="#FDFDFD" className="w-[16px] h-[16px] mr-[4px]" />

              <span className="text-xs text-[#FDFDFD] font-bold">Promoted</span>
            </div>
          )}

          <img
            src={`${imagePrefix}${job.cover_image || job.images?.[0] || ''}`}
            alt={job.job_title}
            className="w-full h-full rounded-[6px]"
          />
        </div>

        <div className="min-h-[358px] flex flex-col items-start bg-[#fff5ee] border-[#ffca84] border-[1px] rounded-[6px] ml-[10px] flex-1 p-[20px]">
          <div className="w-full flex items-start pb-[10px] border-b-[#F9E0CD] border-b-[1px]">
            <div className="flex-1 flex items-start flex-col">
              <h5 className="text-base text-primary-100 font-semibold mb-[10px]">
                {job.job_category.name}
              </h5>

              <h6
                className="text-[20px] leading-[24px] font-bold text-primary-100"
                onClick={handleDetails}
              >
                {job.job_title}
              </h6>

              <p className="text-lg font-bold text-primary-100 mt-[4px]" onClick={handleDetails}>
                {job.post_title}
              </p>
            </div>

            <div className="ml-[8px] flex flex-col justify-center items-end">
              <div className="flex items-center">
                <img
                  src="/assets/icon/euro-coin.svg"
                  className="w-[24px] h-[24px]"
                  alt="Euro coin"
                />

                <span className="ml-[8px] text-base font-bold text-primary-100">
                  € {job.price}
                  {priceType?.value === 'hourly' ? '/hour' : ''}
                </span>
              </div>

              <span className="mt-[4px] rounded-[8px] bg-primary-button h-[28px] px-[8px] text-sm text-white font-bold flex items-center">
                {priceType?.label} Job
              </span>
            </div>
          </div>

          <div className="w-full flex items-start flex-col mt-[16px]">
            <div className="w-full flex items-end justify-between">
              <span className="inline-block flex-1 mr-[16px] text-[18px] font-bold text-primary-100 text-ellipsis whitespace-nowrap overflow-hidden">
                {getUserName(
                  job.job_creator,
                  job.creator_profile.display_name,
                  job.creator_profile.display_last_name
                )}
              </span>

              <div className="gap-x-[16px] flex items-center">
                <div className="flex justify-center items-center">
                  <img
                    className="w-[24px] h-[24px]"
                    src="/assets/icon/checkbox-multiple-line.svg"
                    alt="Checkbox"
                  />

                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {job.tutor_stats?.total_bookings || 0}
                  </span>
                </div>

                <div className="flex justify-center items-center">
                  <img className="w-[24px] h-[24px]" src="/assets/icon/user-green.svg" alt="User" />

                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {job.tutor_stats?.total_students || 0}
                  </span>
                </div>

                <div className="flex justify-center items-center">
                  <img className="w-[24x] h-[24px]" src="/assets/icon/star.svg" alt="Star" />

                  <span className="font-normal ml-1 text-sm text-[#F67443]">
                    {job.tutor_stats?.overall_rating_average || 0}
                  </span>
                </div>

                <div className="flex justify-center items-center">
                  <span className="text-[#B733DD] text-sm font-semibold">ROI</span>
                  <span className="text-[#F67443] font-normal ml-1 text-sm">{job.roi || 0}%</span>
                </div>
              </div>
            </div>

            {/* TODO */}
            <div className="mt-[8px] flex items-center">
              <div aria-hidden className="w-[12px] h-[12px] rounded-full bg-[#1AC057]" />

              <span className="ml-[4px] text-sm font-normal text-primary-100">Online</span>
            </div>

            <div className="w-full flex items-start mt-[10px]">
              <p className="flex-1 text-primary-100 text-sm font-normal line-clamp-4">
                {job.description}
              </p>

              <button
                className="ml-[12px] rounded-[8px] h-[32px] shadow-button border-primary-button border-[1px] w-[200px] bg-white flex items-center justify-center text-sm font-semibold text-primary-button transition-colors duration-200 ease hover:!text-white hover:!bg-primary-button"
                onClick={handleDetails}
              >
                Contact Details
              </button>
            </div>
          </div>

          <div className="mt-auto pt-[16px] flex items-center">
            <Icon name="time-fill" color="#F79009" className="w-[18px] h-[18px]" />

            <span className="ml-[8px] text-sm font-normal text-primary-100">
              Posted {moment(job.date_created).from()}
            </span>
          </div>

          <div className="w-full flex items-center justify-between mt-[16px]">
            <div className="flex items-center">
              <img src="/assets/icon/lang.svg" alt="Language" className="mr-[8px]" />

              <ul className="flex items-center gap-x-[4px]">{languagesContent}</ul>
            </div>

            <div className="flex items-center justify-center gap-x-[24px]">
              <div className="flex items-center justify-center">
                <Icon className="mr-[4px]" name="global-line" color="#F79009" />

                <img className="block" src="/assets/image/America_Flag.svg" alt="us" />
              </div>

              <div className="flex items-center justify-center">
                <Icon className="mr-[4px]" name="home" color="#F79009" />

                <img className="block" src="/assets/image/Canada_Flag.svg" alt="us" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Job
